/**
 * What a Bygg paket package contains, as sub-rows under its one price line
 * (P25009-403, BR-1 and BR-3).
 *
 * A package is one purchase unit: one line, one price, one delivery. The rims
 * and tyres inside it are shown so the buyer knows what is coming and the
 * seller knows what to pull off the shelf — but they carry no price of their
 * own, because the package line above already covers them. Giving each part a
 * price here would double the order total and turn "1 × Komplett hjulsats" into
 * eight articles, which is exactly the confusion this ticket removes.
 *
 * The parts come from `transaction.protectedData.packageParts`, written by the
 * privileged endpoints from the seller's real listings — never from the
 * browser. Before the order exists (the speculative checkout preview) there is
 * no protectedData yet, so the package listing's own `reachBundle` is read
 * instead. Both describe the same parts; one is a snapshot of what was ordered,
 * the other of what the package holds right now.
 *
 * The listing is taken from the `listing` prop when the caller has one and from
 * `transaction.listing` otherwise. The checkout page needs the prop: the
 * transaction it renders is speculative and carries no listing relationship, so
 * without it the preview would show a package with no contents and the sub-rows
 * would appear only after the buyer had paid.
 */
import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { packagePartsOf, packagePartLabel } from '../../util/packageBundleCore';

import css from './OrderBreakdown.module.css';

const LineItemPackagePartsMaybe = props => {
  const { transaction, listing } = props;

  const ordered = transaction?.attributes?.protectedData?.packageParts;
  const parts =
    Array.isArray(ordered) && ordered.length > 0
      ? ordered
      : packagePartsOf(listing || transaction?.listing);

  if (!Array.isArray(parts) || parts.length === 0) {
    return null;
  }

  return (
    <div className={css.packageParts}>
      <span className={css.packagePartsHeading}>Paketet innehåller</span>
      {parts.map((part, i) => (
        <div key={`package-part-${part.listingId || i}`} className={css.packagePart}>
          {packagePartLabel(part)}
        </div>
      ))}
    </div>
  );
};

LineItemPackagePartsMaybe.propTypes = {
  intl: intlShape.isRequired,
};

export default LineItemPackagePartsMaybe;
